<template>
  <base-modal :modal-title="'Column Picker'" @close="close()" @save="save()">
    <div class="panel">
      <div class="panel-body">
        <div class="col-sm-5">
          <h4>Available Columns
            <button class="btn btn-xs btn-link" @click="toggle('columns', 'selected')">{{ toggleTextAvailable }}</button>
          </h4>
          <div class="list-group pre-scrollable columns-list">
            <div class="list-group-item" v-for="column in sortedColumns">
                <input type="checkbox" :value="column" v-model="selected">
                <span v-if="column.field_type == 'S'" class="label label-primary">LS</span> {{ column.name }}
            </div>
          </div>
        </div>
        
        <div class="col-sm-2 column-controls">
          <div>
            <button @click="move('selected', 'picked')" class="btn btn-block btn-success">Add <i class="fa fa-angle-double-right"></i></button>
            <button @click="move('selectedPicked', 'columns')" class="btn btn-block btn-warning"><i class="fa fa-angle-double-left"></i> Remove</button>
          </div>
          <div>
            <button @click="sort('top')" class="btn btn-block btn-default"><i class="fa fa-angle-double-up"></i> Move Top</button>
            <button @click="sort('up')" class="btn btn-block"><i class="fa fa-angle-up"></i> Move Up</button>
            <button @click="sort('down')" class="btn btn-block"><i class="fa fa-angle-down"></i> Move Down</button>
            <button @click="sort('bottom')" class="btn btn-block btn-default"><i class="fa fa-angle-double-down"></i> Move Bottom</button>
          </div>
        </div>
        <div class="col-sm-5">
          <h4>Selected Columns <button class="btn btn-xs btn-link" @click="toggle('picked', 'selectedPicked')">{{ toggleTextPicked }}</button></h4>
          <div class="list-group pre-scrollable columns-list">
            <div class="list-group-item" v-for="column in picked">
                <input type="checkbox" :value="column" v-model="selectedPicked">
                <span v-if="column.field_type == 'S'" class="label label-primary">LS</span> {{ column.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </base-modal>
</template>


<script>
  var _ = require('lodash');

import BaseModal from 'components/modals/BaseModal';

export default {
     components: {
         BaseModal
     },
     props: {
         availableColumns: {
             type: Array
         }
     },
     computed: {
         columnsModel() {
             return _.concat(this.picked, this.columns);
         },
         sortedColumns() {
             return _.sortBy(this.columns, (item => item.slug));
         },
         toggleTextAvailable() {
             return (this.selected.length < this.columns.length ? 'Select' : 'Unselect') + ' all';
         },
         toggleTextPicked() {
             return (this.selectedPicked.length < this.picked.length ? 'Select' : 'Unselect') + ' all';
         }
     },
     data() {
         return {
             selectedPicked: [],
             selected: [],
             picked: [],
             columns: []
         };
     },
     created () {
         var self = this;
         var cols = _.cloneDeep(self.availableColumns);
         cols.forEach(function (item, index) {
             if (item.picked) {
                 self.picked.push(item);
             }
             else {
                 self.columns.push(item);
             }
         });
     },
     methods: {
         close() {
             this.$emit('close');
         },
         save() {
             this.$emit('setColumns', this.columnsModel);
         },
         toggle(source, dest) {
             var self = this;
             if (this[dest].length < this[source].length) {
                 this[dest] = this[source];
             }
             else {
                 this[dest] = [];
             }
         },
         move(source, dest) {
             var self = this;
             var state = dest == 'picked';
             self[source].forEach(function (item, index) {
                 item.picked = state;
                 self[dest].push(item);
             });
             
             var filter_at = state ? 'columns' : 'picked';
             
             self[filter_at] = self[filter_at].filter(function (item, index) {
                 return item.picked == !state;
             });
             
             self[source] = [];
         },
         sort(pos) {
             var self = this;
             switch (pos) {
                 case 'top':
                 case 'bottom':
                     var selected = _.intersection(self.picked, self.selectedPicked);
                     var nonSelected = _.difference(self.picked, self.selectedPicked);
                     if (pos == 'top') {
                         self.picked = _.concat(selected, nonSelected);
                     }
                     else {
                         self.picked = _.concat(nonSelected, selected);
                     }
                     break;
                 case 'up':
                     // TODO refactor this
                     var moved = {};
                     _.forEach(self.picked, function (item, index) {
                         if (_.indexOf(self.selectedPicked, item) > -1) {
                             moved[item.slug] = true;
                             if (index > 0) {
                                 var tmp = self.picked[index - 1];
                                 if (!(tmp.slug in moved)) {
                                     self.$set(self.picked, index - 1, item);
                                     self.$set(self.picked, index, tmp);
                                 }
                             }
                         }
                     });
                     break;
                 case 'down':
                     var moved = {};
                     var n = self.picked.length;
                     
                     for (var i = n -1; i >= 0; i--) {
                         var item = self.picked[i];
                         if (_.indexOf(self.selectedPicked, item) > -1) {
                             moved[item.slug] = true;
                             if (i < n-1) {
                                 var tmp = self.picked[i + 1];
                                 if (!(tmp.slug in moved)) {
                                     self.$set(self.picked, i + 1, item);
                                     self.$set(self.picked, i, tmp);
                                 }
                             }
                         }
                     }
                     break;
             }
         },
     }
}
</script>

<style scoped>
.panel {
  min-width: 900px;
  box-shadow: none;
}
.pre-scrollable {
  height: 35vh;
}
.column-controls {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: transparent;
  padding: 20px 10px;
  height: 35vh;
}
.columns-list {
  background-color: #efefef;
  padding: 5px 5px;
  border: 1px solid #aaa;
}
.columns-list .list-group-item {
  border-radius: 0px 0px;
}
.columns-list .list-group-item + .list-group-item {
  margin-top: 4px;
}
h4 button {
  display: block;
  float: right;
}
</style>



// WEBPACK FOOTER //
// ColumnsPickerModal.vue?9fb432dc